import { render, staticRenderFns } from "./addpro.vue?vue&type=template&id=2c09f81f&"
import script from "./addpro.vue?vue&type=script&lang=js&"
export * from "./addpro.vue?vue&type=script&lang=js&"
import style0 from "./addpro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports